import { useFormikContext } from "formik";
import { useContext, useEffect } from "react";

import { SubformDataContext } from "./SubformDataProvider";

export const useSetFieldTouched = (name: string) => {
  const { setFieldTouched } = useFormikContext();
  const { isStarted } = useContext(SubformDataContext);

  useEffect(() => {
    if (isStarted) {
      setFieldTouched(name, true);
    }
  }, [name, setFieldTouched, isStarted]);
};
